import { validAdminsList } from "sources/books/employees";

const config = {
    userId: {
        url: validAdminsList,
        inputProps: { name: "userId" },
        propName: "fullNameOrEmail",
        filterPropName: ["fullName", "email"],
        placeholder: "Выберите пользователя",
        unClearable: true,
    },
};

export { config };
